import React from "react";
import {useMutation, useSubscription} from "@apollo/client";
import {QUERY_AREA} from "../registryComponentsGQL.js";
import {Box} from "grommet";
import {DataGrid} from "@mui/x-data-grid";
import {Button as ButtonMui} from "@mui/material";
import {DELETE_AREA} from "./AreaGQL.js";

function Aree(props){

    const [deleteArea]=useMutation(DELETE_AREA); //RICOMINCIARE DA QUESTO E CAMBIARLA

    const { data, loading } = useSubscription(
      QUERY_AREA,
    );

     const columnsPack = [
    { field: 'name', headerName: 'Nome', width: 170 },

    {
    field: 'Modifica',
    headerName: 'Modifica',
    width: 120,
    renderCell: (cellValues) => {
      return (

        <ButtonMui
          variant="contained"
         color="warning"
          onClick={(event) => {
            props?.setElementSel(cellValues.row)
          }}
        >
          Modifica
        </ButtonMui>
      );},
   },
   {
    field: 'Cancella',
    headerName: 'Cancella',
    width: 120,
    renderCell: (cellValues) => {
      return (

        <ButtonMui
          variant="contained"
          color="error"
          onClick={(event) => {
            let res=window.confirm("Sei sicuro di voler eliminare l'area?");
            if(res){
              deleteArea({variables:{ id:cellValues.row.id}})
            }
          }}
        >
          Cancella
        </ButtonMui>
      );},
   }
  ];


    return (
      <Box overflow="auto"  height="100%" width="100%" alignSelf='center' style={{marginTop:'40px'}}>
        <div style={{ height: '72vh', width: '100%' }}>
          <DataGrid
            rows={data && data["clubmate_clubmatearea_clubmatearea"] || []}
            columns={columnsPack}
          />
        </div>
      </Box>
    )
}

export default Aree;